import axiosInstance from './axios-instance';

interface ApiResponse<T> {
  status: boolean;
  data: T;
  message?: string;
}

const get = async <T>(url: string, params?: object): Promise<ApiResponse<T>> => {
  const response = await axiosInstance.get<ApiResponse<T>>(url, { params });
  return response.data;
};

const post = async <T>(url: string, body?: object): Promise<ApiResponse<T>> => {
  const response = await axiosInstance.post<ApiResponse<T>>(url, body);
  return response.data;
};

const postWithAttachment = async <T>(url: string, body?: object): Promise<ApiResponse<T>> => {
  const response = await axiosInstance.post<ApiResponse<T>>(url, body, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

const put = async <T>(url: string, body?: object): Promise<ApiResponse<T>> => {
  const response = await axiosInstance.put<ApiResponse<T>>(url, body);
  return response.data;
};

const remove = async <T>(url: string): Promise<ApiResponse<T>> => {
  const response = await axiosInstance.delete<ApiResponse<T>>(url);
  return response.data;
};

export default { get, post, put, remove, postWithAttachment };
